import axios from 'axios';
import crypto from 'crypto';
import qs from 'qs';
import context from '@/main';
/* eslint-disable */
// const baseUrl = process.env.VUE_APP_SERVICE_URL;
const baseUrl = 'https://backendmarket.youdao.com';
const keyId = 'dictpen-writing';
const signSecretKey = 'kKpWfMFaa7EzPy$c*DnakzbvIMzVK!I';

axios.interceptors.response.use(
  (response) => {
    if (response.data.code === 0) {
      // code=0为成功
      return response.data.data;
    } else {
      context.$popup.open({
        type: 'alert', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
        title: '错误', // 弹窗标题
        descMessage: response.data.msg, // 弹窗描述
        confirmButtonText: '确定', // 确认按钮文案
        confirm: () => {
          // 确认按钮回调
          context.$popup.close();
        }
      });
    //  return Promise.reject(response);
    }
  },
  (err) => {
    context.$popup.open({
      type: 'alert', // center：页面中间， bottom: 底部弹窗、alert：确认弹窗
      title: '错误', // 弹窗标题
      descMessage: err.response.data.msg, // 弹窗描述
      confirmButtonText: '确定', // 确认按钮文案
      confirm: () => {
        // 确认按钮回调
        context.$popup.close();
      },
    });
    return Promise.reject(err);
  },
);

/**
 * md5加密
 * @param {String} str md5
 * @param {*} decode
 */
function md5(str, decode) {
  return crypto
    .createHash('md5')
    .update(str)
    .digest(decode);
}

/**
 * 生成签名
 * @param {*} data
 */
function genSign(data) {
  const keySortArr = Object.keys(data)
    .sort()
    .filter((v) => !(data[v] === undefined));
  console.log('keySortArr', keySortArr);
  const sign = `${keySortArr
    .map((k) => `${k}=${data[k]}`)
    .join('&')}&key=${signSecretKey}`;
  console.log('sign', sign);
  return md5(sign, 'hex');
}

const applyPen = (param) => {
  const url = `${baseUrl}/dictpen/fourth/insertuserdata`;
  const signData = Object.assign(param, {
    keyid: keyId,
  });
  const sign = genSign(signData);
  signData.sign = sign;
  return axios.post(url, qs.stringify(signData));
};

const checkStart = () => {
  const url = `${baseUrl}/dictpen/fourth/checkstart`;
  return axios.get(url);
};
const secondCheckStart = () => {
  const url = `${baseUrl}/dictpen/fourth/secondcheckstart`;
  return axios.get(url);
};

const saveTeacher = (param) => {
  const url = `${baseUrl}/dictpen/fourth/saveteacherinfo`;
  const signData = Object.assign(param, {
    keyid: keyId,
  });
  const sign = genSign(signData);
  signData.sign = sign;
  return axios.post(url, qs.stringify(signData));
};

const checkUserInfo = (param) => {
  const url = `${baseUrl}/dictpen/fourth/checkUserInfo`;
  const signData = Object.assign(param, {
    keyid: keyId,
  });
  const sign = genSign(signData);
  signData.sign = sign;
  return axios.post(url, qs.stringify(signData));
};

export default {
  applyPen,
  checkStart,
  saveTeacher,
  checkUserInfo,
  secondCheckStart,
};
